import { render, staticRenderFns } from "./OperaActivityWindow.vue?vue&type=template&id=9c644780&scoped=true&"
import script from "./OperaActivityWindow.vue?vue&type=script&lang=js&"
export * from "./OperaActivityWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaActivityWindow.vue?vue&type=style&index=0&id=9c644780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c644780",
  null
  
)

export default component.exports